import { createSlice } from '@reduxjs/toolkit';
import { getFocusSkuHistoryThunk } from './thunk/focusSkuHistoryThunk';

const focusSkuHistorySlice = createSlice({
  name: 'focusSkuHistory',
  initialState: {
    data: { content: [], totalPages: 0, totalElements: 0, number: 0 },
    isLoading: false,
    error: null,
  },
  reducers: {
    clearFocusSkuHistory: (state) => {
      state.data = { content: [], totalPages: 0, totalElements: 0, number: 0 };
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getFocusSkuHistoryThunk.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getFocusSkuHistoryThunk.fulfilled, (state, action) => {
        state.isLoading = false;
        const newData = action.payload || { content: [], totalPages: 0, totalElements: 0, number: 0 };
        
        // If it's the first page (page 0), replace the data
        if (newData.number === 0) {
          state.data = newData;
        } else {
          // For subsequent pages, append the content to existing data
          state.data = {
            ...newData,
            content: [...state.data.content, ...newData.content]
          };
        }
      })
      .addCase(getFocusSkuHistoryThunk.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || action.error;
      });
  },
});

export const { clearFocusSkuHistory } = focusSkuHistorySlice.actions;
export default focusSkuHistorySlice.reducer; 